import { Session, User, UserType } from "pods/auth/data/fetchSession";

export default function getUser(rawUser: Session): User & { type: UserType } {
  return Object.assign({}, rawUser[rawUser.type], {
    type: rawUser.type,
  });
}
